export default __webpack_public_path__ + "static/media/Alimentacao.97ea047d.svg";